import React, {useState} from "react";
import downloadIcon from "../../../resources/import download.png";
import SocialMedia from "./SocialMedia";
import {handleDownloadFile} from "../../../utils/HandleDownload";
import TypeIt from "typeit-react";

const Caption = ({fullName, jobName, captionHero, socialMedias, cv}) => {

    const [loading, setLoading] = useState(false);
    const job = "Software Developer";
    const handlePrintPdf = () => {
        setLoading(true);
        handleDownloadFile('file/download', { fileName: cv})
            .then(r => {
                // console.log("success");
            })
            .catch(() => {
                alert('Kesalahan mendownload file');
            })
            .finally(() => {
                setLoading(false);
            })
    }
    
    return(
        <div className="space-y-8">
            <div className="space-y-6">
                {/* Greeting */}
                <div className="space-y-4">
                    <p className="text-lg lg:text-xl text-slate-600 dark:text-slate-400 font-medium flex items-center gap-2 transition-colors duration-300">
                        <span className="text-2xl">👋</span> Hello, I'm
                    </p>
                    
                    {/* Name with TypeIt animation */}
                    {(fullName && jobName) ? (
                        <div className="text-4xl lg:text-6xl xl:text-7xl font-bold text-slate-900 dark:text-white leading-tight transition-colors duration-300">
                            <TypeIt
                                options={{
                                    speed: 100,
                                    waitUntilVisible: true,
                                    lifeLike: true,
                                }}
                                getBeforeInit={(instance) => {
                                    instance
                                        .type(fullName)
                                        .pause(2000)
                                        .delete(fullName.length)
                                        .pause(1000)
                                        .type(jobName)
                                        .pause(2000)
                                        .delete(jobName.length)
                                        .pause(1000)
                                        .type(fullName)
                                
                                    return instance;
                                }}
                            />
                        </div>
                    ) : (
                        <div className="text-4xl lg:text-6xl xl:text-7xl font-bold text-slate-900 dark:text-white leading-tight transition-colors duration-300">
                            Fadhlih Girindra Putra
                        </div>
                    )}
                </div>
                
                {/* Description */}
                <p className="text-lg lg:text-xl text-slate-600 dark:text-slate-400 leading-relaxed max-w-2xl font-light transition-colors duration-300">
                    {captionHero}
                </p>
            </div>
            
            {/* Action buttons */}
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
                <button 
                    onClick={handlePrintPdf} 
                    disabled={loading}
                    className="group relative inline-flex items-center gap-3 bg-slate-900 hover:bg-slate-800 dark:bg-slate-100 dark:hover:bg-white text-white dark:text-slate-900 font-semibold py-4 px-8 rounded-2xl transition-all duration-300 disabled:opacity-70 disabled:cursor-not-allowed shadow-sm hover:shadow-md"
                >
                    <span className="relative z-10">
                        {loading ? 'Downloading...' : 'Download CV'}
                    </span>
                    <img 
                        width="24" 
                        height="24" 
                        src={downloadIcon} 
                        alt="download" 
                        className="transition-transform group-hover:translate-y-[-2px] dark:invert"
                    />
                </button>
                
                <SocialMedia socialMedias={socialMedias} />
            </div>
        </div>
    )
}
export default Caption;